import InfoLoader from '@/components/shared/loader/info-loader';
import { Skeleton } from '@/components/ui/skeleton';

const loadingItems = Array(10).fill(1);

const StopRow = () => (
  <div className="flex gap-4">
    <div className="flex flex-col gap-1 min-w-[68px] pt-0.5">
      <Skeleton className="h-3.5 rounded-lg" />
      <Skeleton className="h-3.5 rounded-lg" />
    </div>
    <div className="flex flex-col items-center">
      <Skeleton className="w-4 h-4 rounded-full shrink-0" />
      <Skeleton className="w-1 flex-1 min-h-8" />
    </div>
    <div className="flex items-start pt-0.5">
      <Skeleton className="min-w-[182px] h-3.5 rounded-lg" />
    </div>
  </div>
);

const RouteDetailsLoader = () => {
  return (
    <div className="flex flex-col p-4 gap-4">
      <div className="flex flex-col gap-4">
        <InfoLoader />
        <div className="flex items-center gap-2">
          <Skeleton className="grow h-9 rounded-lg" />
          <Skeleton className="grow h-9 rounded-lg" />
          <Skeleton className="grow h-9 rounded-lg" />
        </div>
      </div>

      <div className="border-b flex gap-6 pb-3 pt-3">
        <Skeleton className="w-20 h-4 rounded-lg" />
        <Skeleton className="w-14 h-4 rounded-lg" />
        <Skeleton className="w-24 h-4 rounded-lg" />
      </div>

      <div className="flex flex-col">
        {loadingItems.map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <StopRow key={index} />
        ))}
      </div>
    </div>
  );
};

export default RouteDetailsLoader;
